import React from 'react';


{/* <Route path="/dashboard/*" element={<DashboardRoot />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/ourapproach" element={<OurApproach />} />
        <Route path="/register" element={<Signup />} />
        <Route path="/contactus" element={<ContactUsPage />} />
        <Route path="/availability" element={<AvailabilitySettings />} />
        <Route path="/doctor/dashboard" element={<DashboardDoctor />} /> */}



const Sitemap: React.FC = () => {
  const links = [
    { title: 'Home', url: '/' },
    { title: 'Dashboard', url: '/dashboard' },
    { title: 'Pricing', url: '/pricing' },
    { title: 'Our Approach', url: '/ourapproach' },
    { title: 'Register', url: '/register' },
    { title: 'Contact Us', url: '/contactus' },
    { title: 'Availability', url: '/availability' },
    { title: 'Doctor Dashboard', url: '/doctor/dashboard' },
    { title: 'Assesment Results', url: '/appointments' },
    { title: 'assesment', url: '/assessments' },

    // Add more links here
  ];

  return (
    <div className='container item-center items-center justify-center px-4 py-8  w-full m-auto'>
      <h1 style={{ color: 'black' }}>Sitemap</h1>
      <ul>
        {links.map((link, index) => (
          <li key={index}>
            <a href={link.url} style={{ color: 'blue' }}>{link.title}</a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sitemap;